export default class NHError extends Error {
  constructor(message, internal = true) {
    super(message);
    this.name = "NHError";
    this.internal = internal;
  }
}
